/**
 * House prefix vs compact chrome.
 *
 * Picker / menu names keep `Afiat -` so house studies stay grouped. Chart
 * legends and Pine `shorttitle`s carry the short house code `AF`
 * ("Afiat - Eureka" reads "AF Eureka"). The Read tiles, breadth lanes and
 * scanner/watchlist headers drop the prefix altogether: the tile is "Eureka".
 * `MPP -` / `JP -` are the old prefixes, still found in custom titles a user
 * typed before the rename, and are stripped the same way.
 */
const HOUSE_PREFIX = /^(?:Afiat|MPP|JP)\s*[-–·]\s*/i;
const AFIAT_PREFIX = /^Afiat\s*[-–·]\s*/i;

export function studyShortName(name: string): string {
  return name.replace(HOUSE_PREFIX, "").trim();
}

/** Legend form: a house study reads `AF <name>`; anything else is stripped. */
export function studyLegendName(name: string): string {
  if (AFIAT_PREFIX.test(name)) return `AF ${name.replace(AFIAT_PREFIX, "").trim()}`;
  return studyShortName(name);
}

/** Table-header form: a user-typed custom title wins; otherwise strip. */
export function chromeStudyLabel(
  label: string,
  customLabel?: string | null,
): string {
  const custom = customLabel?.trim();
  return custom || studyShortName(label);
}
